import React, { PureComponent } from 'react';
import Layout from '../components/complex/layout';
import AlertsList from './dashboard/alertsList';
import BannerAlertsList from './dashboard/bannerAlertsList';
import ModalComponent from '../components/complex/modalComponent';
import actionsConstant from '../../constants/actions';
import LinkEditModal from '../screens/links/linksList/linkEditModal';
import BannerPublishModal from '../screens/banners/bannerPublishModal';
import appConstant from '../../constants/app';
import axios from 'axios';
import { Redirect } from 'react-router-dom';

class Dashboard extends PureComponent {
  state = {
    isActive: false,
    body: '',
    links: [],
    banners: [],
    title: '',
  }

  fetchBrokenLinks = () => {
    let url = `${appConstant.API_URL}/link?from=dashboard`;
    axios.get(url)
      .then(res => {
        const links = res.data.links;
        this.setState({
          links,
        });
      }).catch(err => {
        console.log(err);
      });
  }

  fetchBanners = () => {
    let url = `${appConstant.API_URL}/banner/pending`;
    axios.get(url)
      .then(res => {
        const banners = res.data.banners;
        this.setState({
          banners,
        });
        console.log('BANNERS',res.data.banners)
      }).catch(err => {
        console.log(err);
      });
  }

  componentDidMount () {
    this.fetchBrokenLinks();
    this.fetchBanners();
  }

  onToggleModal = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  onHandleModal = (id, action) => {
    this.setState({id});
    this.onToggleModal();

    if(action === actionsConstant.edit) {
      this.setState({
        title: "Edit link",
        body: <LinkEditModal
          linkId={id}
          onClose={this.onToggleModal}
          onAccept={this.onAccept}
        />,
      });
    }
  }

  onHandleBannerModal = (banner) => {
    this.onToggleModal();

    this.setState({
      title: "Banner request",
      body: <BannerPublishModal
        data={banner}
        onClose={this.onToggleModal}
        refreshRequests={this.fetchBanners}
      />,
    });
  }

  render () {
    const {
      isActive,
      body,
      title,
      links,
      banners,
    } = this.state;

    if (+localStorage.getItem('roleId') === 2) {
      return <Redirect to="/banners" />
    }

    return (
      <Layout>
        <h1 className="main-title">Welcome, Admin!</h1>
        <AlertsList
          list={links}
          showModalHandle={this.onHandleModal}
        />
        <BannerAlertsList
          bannersList={banners}
          showModalHandle={this.onHandleBannerModal}
        />
        <ModalComponent
          isActive={isActive}
          onClose={this.onToggleModal}
          title={title}
          body={body}
        />
      </Layout>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/app/screens/dashboard.js